module.exports = __webpack_public_path__ + "static/media/aspen_logo_white.dc01108c.webp";